import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  headingContainer: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 30
  },
  legendContainer: {
    marginBottom: 10,
    '& ul li:first-child': {
      marginLeft: '0 !important'
    }
  },
  chartWrapper: {
    overflowX: props => (props.isScrollable ? 'auto' : 'visible'),
    overflowY: 'hidden',
    position: 'relative',
    height: 300,
    '&::-webkit-scrollbar': {
      height: 8
    },
    '&::-webkit-scrollbar-track': {
      background: '#f1f1f1',
      borderRadius: 4
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#888',
      borderRadius: 4,
      '&:hover': {
        background: '#555'
      }
    }
  },
  chartCanvas: {
    width: props => (props.chartWidth ? `${props.chartWidth}px` : '100%'),
    height: '100%'
  }
})

export default useStyles
